import { IconBase, type IconProps } from './IconBase';

export function PlayIcon(props: IconProps) {
  return (
    <IconBase size={14} filled {...props}>
      <path d="M8 5l11 7-11 7z" />
    </IconBase>
  );
}
